/**
 * Фразы стола. Человек читает одну строку, не stack и не code:-1.
 */

export const ADS_COPY = {
  down: 'AdsPower не запущен. Платный клиент, тумблер Local API, порт 50325. Ленту открой в обычном Edge на этом ПК — из профиля AdsPower 127.0.0.1 часто не слышен.',
  isolated: 'Лента открыта не в том браузере. Стол настраивается в обычном Edge на компьютере, где крутится AdsPower. Из профиля 50325 не достучаться.',
  unauthorized: 'Ключ стола устарел. Смени в AdsPower и вставь заново. Старый в чат не кидай.',
  byClosed: 'Окно контор закрыто. Нажми открыть столы.',
  trClosed: 'Окно бирж закрыто. Нажми открыть столы.',
  cdpTimeout: 'Окно есть, адрес не доехал. Не ставь вслепую. Ещё раз клик или открой столы.',
  oldZip: 'в этом окне старый подтверждатель. Залей тот же архив в AdsPower → Расширения.',
  noKey: 'Вставь ключ стола. Он живёт только в этом браузере, не на сервере.',
  noProfiles: 'Выбери два профиля: конторы и биржи.',
  sameProfiles: 'Конторы и биржи — разные профили. Один отпечаток на два IP площадки склеивают.',
  opening: 'Столы ещё открываются.',
  corridor: 'Стол только для вилки из двух ног. Коридор открой с выключенным столом.',
  sameSeat: 'Стол — контора слева и биржа справа. Две конторы или две биржи открой с выключенным столом.',
  unknownSeat: 'Не знаем, в какое окно это открыть. Не ставь вслепую.',
  pairFailed: 'Пара не открылась целиком. В обычный Edge не кладём — будет домашний IP.',
  noExt: 'Расширение не отвечает. Обнови архив в Edge, версия не ниже порога ленты.',
  noPerm: 'Разреши расширению ходить на локальный AdsPower. Нажми «открыть столы» ещё раз.',
  needSetup: 'Сначала ключ и два профиля, потом открой столы.',
  bannedCdp: 'Стол не жмёт кнопки и не закрывает профиль.',
  busy: 'Этот стол уже открыт на другом компьютере. В первой версии — один ПК на ключ.',
  profileClosed: 'профиль AdsPower не запущен — нажмите «открыть столы» в студии',
  cdpRefused: 'профиль открыт, но не пускает стол к окнам — нажмите «открыть столы»: перезапустим профиль с доступом',
  noBook: 'Нет профиля AdsPower для кассы — выберите два профиля стола в студии (шаг «стол»):',
  noBooks: 'Выберите два профиля стола в студии (шаг «стол»), потом откройте столы.',
  oldDesk: 'Расширение в Edge старое для столов AdsPower — замените архив на новый (forq-extension.zip).',
  deskNoExt: 'Стол AdsPower включён, а расширение в Edge не отвечает. Обновите архив или выключите стол в студии. В Edge без прокси не открываем.',
  tooMany: 'Стол открывает до трёх касс за раз.',
} as const;

export type AdsPhrase = (typeof ADS_COPY)[keyof typeof ADS_COPY];

export function phraseOf(err: unknown, seat?: 'by' | 'tr'): string {
  if (typeof err === 'string' && err.length > 0) {
    for (const one of Object.values(ADS_COPY)) {
      if (err === one || err.includes(one)) return err;
    }
  }
  const text = err instanceof Error ? err.message : String(err ?? '');
  const low = text.toLowerCase();
  if (low.includes('401') || low.includes('unauthorized') || low.includes('api key')) {
    return ADS_COPY.unauthorized;
  }
  if (low.includes('failed to fetch') || low.includes('networkerror') || low.includes('econnrefused')) {
    return ADS_COPY.down;
  }
  if (low.includes('timeout') || low.includes('timed out')) return ADS_COPY.cdpTimeout;
  if (low.includes('cloud') && low.includes('active')) return ADS_COPY.busy;
  if (seat === 'by') return ADS_COPY.byClosed;
  if (seat === 'tr') return ADS_COPY.trClosed;
  if (text.trim() !== '') return text;
  return ADS_COPY.down;
}

export function fromAdsCode(code: number, msg?: string): string {
  if (code === 0) return '';
  if (code === -1 && (msg ?? '').toLowerCase().includes('not found')) return ADS_COPY.down;
  if (code === 401 || code === -401) return ADS_COPY.unauthorized;
  return phraseOf(msg ?? `code:${code}`);
}
